import SvgIcon from '@/components/common/SvgIcon'
import ButtonCustom from '@/components/ui/ui-react-antd/MyButton/Button'
import { useGoogleLogin } from '@/features/IndentityLogin/queries'
import ROUTER from '@/routes/ROUTER'
import { Col, Row } from 'antd'
import styled from 'styled-components'

const Styled = styled.div`
  .box {
    background: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 4px;
    display: flex;
    padding: 14px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 100%;
    height: auto !important;
  }
`

const FormLoginSocial = () => {
  const { handleGoogleLogin } = useGoogleLogin()

  return (
    <Styled>
      <Row gutter={16}>
        <Col span={24}>
          <ButtonCustom
            className="login-button-primary-gg"
            onClick={() => {
              handleGoogleLogin({ returnUrl: `${window.location.origin}${ROUTER.AUTH_CALLBACK}` })
              // onLoginSuccess()
            }}
            // disabled={loading}
            // loading={loading}
          >
            <div
              className="ml-0"
              style={{
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <SvgIcon name="login-google" style={{ paddingRight: 5 }} />
              <span>Đăng nhập bằng Google</span>
            </div>
          </ButtonCustom>
        </Col>
      </Row>
    </Styled>
  )
}

export default FormLoginSocial
